import { gql } from '@common/hooks';
import { FullValidationErrorFragment } from '@common/graphql/fragments';
import { DetailItemAttachments } from '@onboarding/graphql/fragments';

const UpdateNurseCertificationMutation = gql`
  mutation UpdateNurseCertificationMutation(
    $id: ID!
    $certificationId: ID!
    $input: UpdateNurseCertificationInput!
    $files: [FileUploadInput!]!
  ) {
    updateNurseCertification(
      id: $id
      certificationId: $certificationId
      input: $input
      files: $files
    ) {
      nurseCertification {
        id
        certificationUuid
        name
        issuingBody
        expiresOn
        isExpired
        isExpiringSoon
        detailItemAttachments {
          ...DetailItemAttachments
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
  ${DetailItemAttachments}
`;

const CreateNurseCertificationMutation = gql`
  mutation CreateNurseCertificationMutation(
    $worksProfileId: ID!
    $worksListItemId: ID!
    $certificationId: ID!
    $input: CreateNurseCertificationInput!
    $files: [FileUploadInput!]!
  ) {
    createNurseCertification(
      worksProfileId: $worksProfileId
      worksListItemId: $worksListItemId
      certificationId: $certificationId
      input: $input
      files: $files
    ) {
      nurseCertification {
        id
        certificationUuid
        name
        issuingBody
        completedOn
        expiresOn
        isExpired
        isExpiringSoon
        detailItemAttachments {
          ...DetailItemAttachments
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
  ${DetailItemAttachments}
`;

export { UpdateNurseCertificationMutation, CreateNurseCertificationMutation };
